module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"launcher":"Launcher","launcherSubTitle":"Select an application"},"fr":{"launcher":"Lanceur","launcherSubTitle":"Choisissez une application"}}')
  delete Component.options._Ctor
}
